'use client'

import { Badge } from '@/components/ui/badge'
import Image from 'next/image'
import logo from '@/assets/logo.svg'

export default function AuthHeader({ badge }: { badge?: string }) {
  return (
    <div className='text-center mb-8'>
      <div className='flex items-center justify-center space-x-2 mb-4'>
        <Image
          src={logo}
          alt='Logo'
          width={190}
          height={75}
          className='rounded-md'
        />
      </div>
      {badge ? <Badge variant='soft'>{badge}</Badge> : null}
    </div>
  )
}
